import React  from 'react'

import FormManager from "../../../../../../../core/gd-form/common/form-manager"
import FormError from "../../../../../../../core/gd-form/common/form-error/form-error"
import CustomView_rowComponent from "./row-component"

// @ts-ignore
import SelectTaskType from "../../../../../../../core/gd-ui/select-task-type/select-task-type"

type Props = {
    form                : FormManager
    formFieldName       : string
    allowedTaskTypes    : ID[]

    disabled?           : boolean
}

export default function SelectTaskTypeMulti(props: Props) {
    return (
        <CustomView_rowComponent label="Task types">
            <SelectTaskType form                = {props.form}
                            name                = {props.formFieldName}
                            multiselect         = {true}
                            allowedTaskTypes    = {props.allowedTaskTypes}
                            renderValue         = "form"
                            underlined          = "always"
                            placeholder         = "All task types"
                            canHaveNoValue      = {true}
                            noValueValue        = {[]}
                            noValueLabel        = "All task types"
                            disabled            = {props.disabled}/>
            <FormError form = {props.form}
                       name = {props.formFieldName}/>
        </CustomView_rowComponent>
    )
}

SelectTaskTypeMulti.defaultProps = {
    formFieldName   : "taskTypes",
}